var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.3 3.1h-13L0 10.2v12.7h26V10.2zM6.6 4H19l5.9 6.2h-7l-.8 3H8.7l-.8-3H1.2zm18.5 18H.9V11h6.4l.8 3h9.7l.8-3h6.6v11z"
})));
export default SvgEmpty;